export const AI_VOICEOVER_DISABLED_MESSAGE =
    'AI voiceover is disabled for this account. Contact your admin to enable it.';
